import { formatNumberAndCents, kebabCase } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { NET_CASH_PAYOUT } from '../../../constants';
import { useHeldSelector } from '../../../hooks/useHeldSelector';

export const useNetCashPayoutField = () => {
    const netCashPayoutValue = useHeldSelector(offerReduxSelectors.getNetCashPayout);
    const fieldName = kebabCase(NET_CASH_PAYOUT);

    return {
        label: NET_CASH_PAYOUT,
        inputProps: {
            name: fieldName,
            value: formatNumberAndCents(netCashPayoutValue),
            'data-testid': fieldName
        }
    };
};
